module.exports = __webpack_public_path__ + "static/media/flask2-background.2ea38c13.png";